import React from 'react';
import { Row, Col, Typography, Space, Button } from 'antd';

const { Title, Text } = Typography;

const PageHeader = ({ 
    title, 
    description, 
    buttonText,
    buttonIcon,
    onButtonClick,
    style = {}
}) => {
    return (
        <div style={{ 
            background: 'linear-gradient(180deg, #ffffff 0%, #fafafa 100%)',
            padding: '32px 24px',
            margin: '0 0 32px 0',
            borderBottom: '1px solid #e8e8e8',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.8)',
            position: 'relative',
            ...style
        }}>
            <Row justify="space-between" align="center" gutter={[16, 16]}>
                <Col flex="auto">
                    <Space direction="vertical" size={6} style={{ width: '100%' }}>
                        <Title level={3} style={{ 
                            margin: 0, 
                            color: '#262626',
                            fontWeight: '600',
                            fontSize: '24px',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            lineHeight: '1.3'
                        }}>
                            {title}
                        </Title>
                        {description && (
                            <Text style={{ 
                                color: '#8c8c8c',
                                fontSize: '14px',
                                lineHeight: '1.5',
                                textShadow: '0 1px 1px rgba(255,255,255,0.8)',
                                margin: 0
                            }}>
                                {description}
                            </Text>
                        )}
                    </Space>
                </Col>
                {buttonText && (
                    <Col flex="none">
                        <Button
                            type="primary"
                            icon={buttonIcon}
                            onClick={onButtonClick}
                            style={{
                                height: '40px',
                                padding: '0 24px',
                                borderRadius: '6px',
                                fontWeight: '500',
                                fontSize: '14px',
                                background: 'linear-gradient(180deg, #1890ff 0%, #096dd9 100%)',
                                border: '1px solid #096dd9',
                                boxShadow: '0 2px 4px rgba(24, 144, 255, 0.3), inset 0 1px 0 rgba(255,255,255,0.2)',
                                textShadow: '0 1px 1px rgba(0,0,0,0.2)',
                                minWidth: '120px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(180deg, #40a9ff 0%, #1890ff 100%)';
                                e.currentTarget.style.boxShadow = '0 3px 6px rgba(24, 144, 255, 0.4), inset 0 1px 0 rgba(255,255,255,0.3)';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(180deg, #1890ff 0%, #096dd9 100%)';
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(24, 144, 255, 0.3), inset 0 1px 0 rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'translateY(0)';
                            }}
                        >
                            {buttonText}
                        </Button>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default PageHeader; 